export enum DeburringType {
  NO = "NO",
  ONE_SIDED = "ONE_SIDED",
  TWO_SIDED = "TWO_SIDED",
  TROVALIZE = "TROVALIZE",
}
